function Stats({ mode }) {
  return (
    <div className="stats">

      {mode === "college" ? (
        <>
          <div className="stat-box">
            <h2>1200+</h2>
            <p>Students</p>
          </div>

          <div className="stat-box">
            <h2>15+</h2>
            <p>Courses</p>
          </div>

          <div className="stat-box">
            <h2>95%</h2>
            <p>Placement</p>
          </div>

          <div className="stat-box">
            <h2>5000+</h2>
            <p>Library</p>
          </div>
        </>
      ) : (
        <>
          <div className="stat-box">
            <h2>10+</h2>
            <p>Activities</p>
          </div>

          <div className="stat-box">
            <h2>4+</h2>
            <p>Classes</p>
          </div>

          <div className="stat-box">
            <h2>100%</h2>
            <p>Safe Environment</p>
          </div>

          <div className="stat-box">
            <h2>Fun</h2>
            <p>Learning</p>
          </div>
        </>
      )}

    </div>
  );
}

export default Stats;